var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiple-images"},[_c('h2',{staticClass:"gallery-title"},[_vm._v(_vm._s(_vm.galleryTitle))]),_c('ImageMasonry',{attrs:{"images":_vm.images,"showDescription":_vm.showDescription,"cols":_vm.customCols}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }